var _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 665,
    height: 784,
    viewBox: "0 0 665 784",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 665,
    height: 784
  }, /*#__PURE__*/React.createElement("rect", {
    width: 665,
    height: 784,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.5 637.897L152.5 490.897L364.5 0.758521L664.345 0.758515L664.345 507.897L301.5 637.897Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.025 503.39L145.302 490.113C150.207 485.209 158.183 485.217 163.079 490.113L299.597 626.632C304.493 631.528 304.502 639.504 299.597 644.409L293.454 650.552L297.42 654.519C302.273 659.372 302.273 667.271 297.412 672.132L296.31 673.234C291.458 678.086 283.55 678.095 278.689 673.234L274.73 669.276L268.587 675.419C263.691 680.315 255.706 680.315 250.81 675.419L114.292 538.901C109.387 533.996 109.387 526.028 114.292 521.124L127.439 507.976C121.459 502.874 112.476 503.08 106.823 508.733L88.917 526.639C84.3136 531.243 83.1434 538.281 86.0173 544.132L129.737 633.266C135.216 644.443 133.416 657.731 125.368 667.039C125.226 667.204 125.081 667.367 124.935 667.529L135.054 677.648C136.259 678.852 136.31 680.797 135.175 682.07L83.4188 739.54C73.9452 749.013 58.526 749.013 49.0439 739.531C39.5704 730.057 39.5704 714.638 49.173 705.053L106.522 653.417C107.787 652.273 109.731 652.325 110.936 653.529L120.349 662.943C120.47 662.804 120.59 662.665 120.708 662.524C126.875 655.165 128.261 644.835 123.98 636.097L80.2523 546.954C76.1738 538.642 77.8344 528.653 84.3824 522.105L102.288 504.199C110.445 496.042 123.533 495.792 132.025 503.39ZM279.274 664.732L283.232 668.69C285.589 671.048 289.427 671.048 291.776 668.699L292.877 667.598C295.235 665.24 295.235 661.402 292.877 659.045L288.919 655.087L279.274 664.732Z",
    fill: "#101F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.974 667.332L135.093 677.45C136.298 678.655 136.349 680.6 135.213 681.873L83.4575 739.342C73.984 748.816 58.5648 748.816 49.0827 739.334C39.6091 729.86 39.6091 714.441 49.2117 704.856L106.561 653.22C107.825 652.076 109.77 652.128 110.975 653.332L120.388 662.745C120.509 662.607 120.323 662.939 120.441 662.799L125.051 667.409C124.909 667.573 125.12 667.17 124.974 667.332Z",
    fill: "#101F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.974 667.332L135.093 677.45C136.298 678.655 136.349 680.6 135.213 681.873L83.4575 739.342C73.984 748.816 58.5648 748.816 49.0827 739.334C39.6091 729.86 39.6091 714.441 49.2117 704.856L106.561 653.22C107.825 652.076 109.77 652.128 110.975 653.332L120.388 662.745C120.509 662.607 120.323 662.939 120.441 662.799L125.051 667.409C124.909 667.573 125.12 667.17 124.974 667.332Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.164 490.004L131.887 503.281L127.301 507.867L114.153 521.015C109.249 525.919 109.249 533.887 114.153 538.792L250.672 675.31C255.568 680.206 263.553 680.206 268.449 675.31L274.592 669.167L293.316 650.443L299.459 644.3C304.364 639.395 304.355 631.419 299.459 626.523L162.941 490.004C158.045 485.108 150.068 485.1 145.164 490.004Z",
    fill: "#101F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.164 490.004L131.887 503.281L127.301 507.867L114.153 521.015C109.249 525.919 109.249 533.887 114.153 538.792L250.672 675.31C255.568 680.206 263.553 680.206 268.449 675.31L274.592 669.167L293.316 650.443L299.459 644.3C304.364 639.395 304.355 631.419 299.459 626.523L162.941 490.004C158.045 485.108 150.068 485.1 145.164 490.004Z",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 719.5,
    y1: 1097.9,
    x2: 1304.11,
    y2: 462.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#00829C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#4BD8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#00AEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#D5DA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#E9671A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#F96868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "#00AEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885417,
    stopColor: "#4BD8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00829C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 77.4112,
    y1: 680.477,
    x2: 98.0944,
    y2: 702.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#415252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391005,
    stopColor: "#4E5555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 231.372,
    y1: 558.056,
    x2: 195.521,
    y2: 593.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#415252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#4E5555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101F1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.4963c7f54cd7f29e0f1b865cf5347617.svg";
export { ForwardRef as ReactComponent };